import { useEffect, useRef, useState } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, InputValue, TextInput, TextInputProps } from '@optimus-web/core';

export const SearchBar = ({
    onSearchChange,
    defaultSearch = '',
}: {
    onSearchChange?: (search: string) => void;
    defaultSearch?: string;
}) => {
    const searchRef = useRef<HTMLInputElement>(null);
    const [searchQuery, setSearchQuery] = useState(defaultSearch);

    const handleChange: TextInputProps['onChange'] = (_, value: InputValue) => {
        setSearchQuery(String(value));
        onSearchChange?.(String(value));
    };

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'f' && (event.ctrlKey || event.metaKey)) {
                event.preventDefault();
                searchRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <TextInput
            indicativeIcon={IconName.Search}
            placeholder={<LocalizedText textKey={TextKey.Search} />}
            name="search"
            type="search"
            ref={searchRef}
            value={searchQuery}
            onChange={handleChange}
        />
    );
};
